import { render, staticRenderFns } from "./BuyVoucher.vue?vue&type=template&id=fc808862&"
import script from "./BuyVoucher.vue?vue&type=script&lang=js&"
export * from "./BuyVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports